var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['status', _vm.isOnline ? 'status--online' : 'status--offline'],attrs:{"title":[_vm.isOnline ? 'Онлайн' : 'Офлайн']}})
}
var staticRenderFns = []

export { render, staticRenderFns }